<template>
	<div class="conversation-info">
		<div class="conversation-avatar-container">
			<ConversationAvatar
				v-if="
					conversationProviderHasAvatarProvider(
						getCurConversation.providerName
					)
				"
				:providerName="getCurConversation.providerName"
				:conversationId="getCurConversation.id"
				class="rounded lg"
				:key="
					getCurConversation.id
						? 'conversation_' +
						  getCurConversation.providerName +
						  '_' +
						  getCurConversation.id
						: 'conversation_' + getCurConversation.providerName
				"
			/>
			<!-- <button v-else class="conversation-avatar btn action rounded lg"></button> -->
		</div>
		<div class="conversation-info-inner">
			<div class="conversation-name-container input-group">
				<input
					class="conversation-name input rounded lg hardshadow"
					:value="getCurConversation.name"
					readonly="true"
				/>
			</div>

			<div v-if="!oneProviderMode" class="card">
				<b class="clr-secondary" style="margin: 0;">Provider</b>
				<p style="margin-bottom: 0;">
					{{ getCurConversation.providerName }}
				</p>
			</div>
		</div>

		<template v-if="curConversationInfoComponent">
			<hr />
			<div class="conversation-info-component-container">
				<component :is="curConversationInfoComponent" />
			</div>
		</template>
	</div>
</template>

<script>
import ConversationAvatar from './ConversationAvatar.vue';
import { mapGetters } from 'vuex';

export default {
	name: 'ConversationInfo',
	components: {
		ConversationAvatar
	},
	data() {
		return {
			curConversationInfoComponent: null
		};
	},
	mounted() {
		this.$nextTick(() => {
			this.curConversationInfoComponent = this.conversationInfoComponent(
				this.getCurConversation.providerName,
				this.getCurConversation.id
			);
		});
	},
	computed: {
		...mapGetters({
			getCurConversation: 'ConversationProviders/getCurConversation',
			oneProviderMode: 'ConversationProviders/oneProviderMode'
		})
	},
	methods: {
		conversationProviderHasAvatarProvider(providerName) {
			return this.$store.getters[
				'ConversationProviders/provider_' +
					providerName +
					'/getConversationAvatar'
			];
		},
		conversationInfoComponent(providerName, conversationId) {
			if (providerName && conversationId) {
				let component = this.$store.getters[
					'ConversationProviders/provider_' +
						providerName +
						'/conversationInfoComponent'
				];

				if (component && typeof component === 'function') {
					return component(conversationId);
				}
			}
			return null;
		}
	}
};
</script>
